import React, { useState, useEffect ,useContext} from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

export default function ProfilePage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({});
  const [message, setMessage] = useState("");
  const { setIsLoggedIn } = useContext(AuthContext);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/signin");
      return;
    }
    axios
      .get(API_BASE_URL + "users/me", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setUser(res.data);
        setForm({
          email: res.data.email,
          username: res.data.username || "",
          phoneNumber: res.data.phoneNumber || "",
        });
      })
      .catch(() => navigate("/signin"));
  }, [navigate]);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await axios.put(API_BASE_URL + "users/me", form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(res.data);
      setMessage("Profile updated");
    } catch (err) {
      setMessage(err.response?.data?.msg || "Update failed");
    }
  };

  const handleSignOut = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/");
  };

  if (!user) return null;
  return (
    <div className="container py-5" style={{ maxWidth: "500px" }}>
      <h2 className="mb-4 text-center">My Profile</h2>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSave}>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={form.email}
            disabled
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Username</label>
          <input
            type="text"
            name="username"
            className="form-control"
            value={form.username}
            onChange={handleChange}
          />
        </div>
        <div className="mb-4">
          <label className="form-label">Mobile</label>
          <input
            type="text"
            name="phoneNumber"
            className="form-control"
            value={form.phoneNumber}
            onChange={handleChange}
          />
        </div>
        <button className="btn btn-primary w-100 mb-3">Save Changes</button>
      </form>

      <button className="btn btn-outline-danger w-100" onClick={handleSignOut}>
        Sign Out
      </button>
    </div>
  );
}
